Greenmile.Survey = Greenmile.Survey || {};
Greenmile.Survey.Templates = Greenmile.Survey.Templates || {};
Greenmile.Survey.Templates.SurveyApplyRulesTemplate = function () {
  const triggerEvents = Greenmile.Survey.SurveyApplyRule.triggerEvents;
  return new Monet.UI.LayoutGenerator({
    'items': [
      {
        'attributes': {
          'id': 'SurveyTemplateContainer',
        },
        'items': [
          {
            'attributes': {
              'class': 'section-rules',
            },
            'items': [
              {
                'attributes': {
                  'class': 'sidebar',
                },
                'items': [
                  {
                    'tag': 'div',
                    'attributes': {
                      'class': 'sidebar-item',
                    },
                    'items': [
                      {
                        'tag': 'label',
                        'html': Monet.I18n.getResourcesByKey('triggerEvents.RouteEvents'),
                        'attributes': {
                          'class': 'opened'
                        },
                      },
                      {
                        'tag': 'ul',
                        'attributes': {
                          'class': 'opened'
                        },
                        'items': [
                          {
                            'tag': 'li',
                            'html': Monet.I18n.getResourcesByKey(triggerEvents.ROUTE_START_ROUTE),
                            'attributes': {
                              'value': 'ROUTE_START_ROUTE',
                              'ruletype': 'route',
                            },
                          },
                          {
                            'tag': 'li',
                            'html': Monet.I18n.getResourcesByKey(triggerEvents.ROUTE_DEPART_ORIGIN),
                            'attributes': {
                              'value': 'ROUTE_DEPART_ORIGIN',
                              'ruletype': 'route',
                            },
                          },
                          {
                            'tag': 'li',
                            'html': Monet.I18n.getResourcesByKey(triggerEvents.ROUTE_ARRIVE_DESTINATION),
                            'attributes': {
                              'value': 'ROUTE_ARRIVE_DESTINATION',
                              'ruletype': 'route',
                            },
                          },
                          {
                            'tag': 'li',
                            'html': Monet.I18n.getResourcesByKey(triggerEvents.ROUTE_COMPLETE_ROUTE),
                            'attributes': {
                              'value': 'ROUTE_COMPLETE_ROUTE',
                              'ruletype': 'route',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    'tag': 'div',
                    'attributes': {
                      'class': 'sidebar-item',
                    },
                    'items': [
                      {
                        'tag': 'label',
                        'html': Monet.I18n.getResourcesByKey('triggerEvents.StopEvents'),
                        'attributes': {
                          'class': 'opened'
                        },
                      },
                      {
                        'tag': 'ul',
                        'attributes': {
                          'class': 'opened'
                        },
                        'items': [
                          {
                            'tag': 'li',
                            'html': Monet.I18n.getResourcesByKey(triggerEvents.ARRIVE_STOP),
                            'attributes': {
                              'value': 'ARRIVE_STOP',
                              'ruletype': 'stop',
                            },
                          },
                          {
                            'tag': 'li',
                            'html': Monet.I18n.getResourcesByKey(triggerEvents.DEPART_STOP),
                            'attributes': {
                              'value': 'DEPART_STOP',
                              'ruletype': 'stop',
                            },
                          },
                          {
                            'tag': 'li',
                            'html': Monet.I18n.getResourcesByKey(triggerEvents.CANCEL),
                            'attributes': {
                              'value': 'CANCEL',
                              'ruletype': 'stop',
                            },
                          },
                          {
                            'tag': 'li',
                            'html': Monet.I18n.getResourcesByKey(triggerEvents.UNDELIVERABLE),
                            'attributes': {
                              'value': 'UNDELIVERABLE',
                              'ruletype': 'stop',
                            },
                          },
                          {
                            'tag': 'li',
                            'html': Monet.I18n.getResourcesByKey(triggerEvents.REDELIVERY),
                            'attributes': {
                              'value': 'REDELIVERY',
                              'ruletype': 'stop',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    'tag': 'div',
                    'attributes': {
                      'class': 'sidebar-item',
                    },
                    'items': [
                      {
                        'tag': 'label',
                        'html': Monet.I18n.getResourcesByKey('triggerEvents.HOSEvents'),
                        'attributes': {
                          'class': 'opened'
                        },
                      },
                      {
                        'tag': 'ul',
                        'attributes': {
                          'class': 'opened'
                        },
                        'items': [
                          {
                            'tag': 'li',
                            'html': Monet.I18n.getResourcesByKey(triggerEvents.HOS_ON_DUTY),
                            'attributes': {
                              'value': 'HOS_ON_DUTY',
                              'ruletype': 'hos',
                            },
                          },
                          {
                            'tag': 'li',
                            'html': Monet.I18n.getResourcesByKey(triggerEvents.HOS_OFF_DUTY),
                            'attributes': {
                              'value': 'HOS_OFF_DUTY',
                              'ruletype': 'hos',
                            },
                          },
                          {
                            'tag': 'li',
                            'html': Monet.I18n.getResourcesByKey(triggerEvents.HOS_START_BREAK),
                            'attributes': {
                              'value': 'HOS_START_BREAK',
                              'ruletype': 'hos',
                            },
                          },
                          {
                            'tag': 'li',
                            'html': Monet.I18n.getResourcesByKey(triggerEvents.HOS_END_BREAK),
                            'attributes': {
                              'value': 'HOS_END_BREAK',
                              'ruletype': 'hos',
                            },
                          },
                          {
                            'tag': 'li',
                            'html': Monet.I18n.getResourcesByKey(triggerEvents.HOS_START_LUNCH),
                            'attributes': {
                              'value': 'HOS_START_LUNCH',
                              'ruletype': 'hos',
                            },
                          },
                          {
                            'tag': 'li',
                            'html': Monet.I18n.getResourcesByKey(triggerEvents.HOS_END_LUNCH),
                            'attributes': {
                              'value': 'HOS_END_LUNCH',
                              'ruletype': 'hos',
                            },
                          },
                          {
                            'tag': 'li',
                            'html': Monet.I18n.getResourcesByKey(triggerEvents.HOS_START_DRIVE),
                            'attributes': {
                              'value': 'HOS_START_DRIVE',
                              'ruletype': 'hos',
                            },
                          },
                          {
                            'tag': 'li',
                            'html': Monet.I18n.getResourcesByKey(triggerEvents.HOS_END_DRIVE),
                            'attributes': {
                              'value': 'HOS_END_DRIVE',
                              'ruletype': 'hos',
                            },
                          },
                          {
                            'tag': 'li',
                            'html': Monet.I18n.getResourcesByKey(triggerEvents.HOS_START_WAIT),
                            'attributes': {
                              'value': 'HOS_START_WAIT',
                              'ruletype': 'hos',
                            },
                          },
                          {
                            'tag': 'li',
                            'html': Monet.I18n.getResourcesByKey(triggerEvents.HOS_END_WAIT),
                            'attributes': {
                              'value': 'HOS_END_WAIT',
                              'ruletype': 'hos',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    'tag': 'div',
                    'attributes': {
                      'class': 'sidebar-item',
                    },
                    'items': [
                      {
                        'tag': 'label',
                        'html': Monet.I18n.getResourcesByKey('triggerEvents.GreenMileManager'),
                        'attributes': {
                          'class': 'opened'
                        },
                      },
                      {
                        'tag': 'ul',
                        'attributes': {
                          'class': 'opened'
                        },
                        'items': [
                          {
                            'tag': 'li',
                            'html': Monet.I18n.getResourcesByKey(triggerEvents.AT_SURVEYS_SCREEN),
                            'attributes': {
                              'value': 'AT_SURVEYS_SCREEN',
                              'ruletype': 'route',
                            },
                          },
                          {
                            'tag': 'li',
                            'html': Monet.I18n.getResourcesByKey(triggerEvents.AT_TASKS_SCREEN),
                            'attributes': {
                              'value': 'AT_TASKS_SCREEN',
                              'ruletype': 'route',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    'tag': 'div',
                    'attributes': {
                      'class': 'sidebar-item',
                    },
                    'items': [
                      {
                        'tag': 'label',
                        'html': Monet.I18n.getResourcesByKey('triggerEvents.OrderDelivery'),
                        'attributes': {
                          'class': 'opened'
                        },
                      },
                      {
                        'tag': 'ul',
                        'attributes': {
                          'class': 'opened'
                        },
                        'items': [
                          {
                            'tag': 'li',
                            "html": Monet.I18n.getResourcesByKey(triggerEvents.ORDER_DELIVERY),
                            "attributes": {
                                "value": "ORDER_DELIVERY",
                                "ruletype": "order"
                            }
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                'attributes': {
                  'class': 'formContent',
                },
                'items': [
                  {
                    'attributes': {
                      'class': 'rules-description'
                    },
                    'items': [
                      {
                        'tag': 'span',
                        'html': Monet.I18n.getResourcesByKey('surveyApplyRules.rulesDescription')
                      },
                      {
                        'tag': 'span',
                        'attributes': {
                          'class': 'rules-description__selected',
                        },
                      }
                    ]
                  },
                  {
                    'attributes': {
                      'class': 'rules-group'
                    },
                    'items': [
                      {
                        'attributes': {
                          'class': 'monetInlineAlerContainer',
                        },
                      },
                      {
                        'attributes': {
                          'class': 'rules',
                        },
                      }
                    ]
                  },

                  {
                    'attributes': {
                      'class': 'buttonGroup  standard-form-buttons',
                    },
                    'items': [
                      {
                        'tag': 'input',
                        'attributes': {
                          'type': 'button',
                          'class': 'btn i18nResource btn-secondary',
                          'value': Monet.I18n.getResourcesByKey('Survey.filter.btn.cancelButton'),
                          'id': 'LinkFormCancelButton',
                        },
                      },
                      {
                        'tag': 'input',
                        'attributes': {
                          'type': 'button',
                          'class': 'btn i18nResource',
                          'value': Monet.I18n.getResourcesByKey('Survey.filter.btn.saveButton'),
                          'id': 'LinkFormSaveButton',
                          'style': 'float:right;',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  }).render();
};
